import { ICompareFullResponse } from '../../interfaces/compare-report.interface'

export interface ComparatorReportsStateModel {
  reports: ICompareFullResponse
}
